import React, { useState, useEffect, useRef } from 'react'
import { motion, AnimatePresence } from 'framer-motion';

const colors = ["#4A837F","#569278","#8AB29A", "#A1CEA0","#C5DBB8", "#B7E8C5","#A8DFD2","#8DC7B9","#569FA9"]

const RemoteScoreView = ({size, scoreInfo, isArchive}) => {
  const containerStyle = {
    width: '100%',
    height: size * (115 / 300),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }

  console.log(scoreInfo.remoteScoreInfo)
  const histogramX = 110
  const histogramW = 170

  // Use bucketsV2 if available, otherwise fall back to old buckets
  const useBucketsV2 = scoreInfo.remoteScoreInfo.bucketsV2 && scoreInfo.remoteScoreInfo.bucketsV2.length > 0
  const rawBuckets = useBucketsV2 ? scoreInfo.remoteScoreInfo.bucketsV2 : scoreInfo.remoteScoreInfo.buckets

  let buckets = []
  let labels = []

  if (useBucketsV2) {
    // Find the first bucket with data
    const firstDataIndex = rawBuckets.findIndex(bucket => bucket.count > 0)

    if (firstDataIndex === -1) {
      // No data at all, use default 6 buckets from the start
      buckets = rawBuckets.slice(0, 6).map(b => ({ count: b.count }))
      labels = rawBuckets.slice(0, 6).map(b => b.label)
    } else {
      // Show first bucket with data + next 2 individually
      buckets.push({ count: rawBuckets[firstDataIndex].count })
      labels.push(rawBuckets[firstDataIndex].label)

      if (firstDataIndex + 1 < rawBuckets.length) {
        buckets.push({ count: rawBuckets[firstDataIndex + 1].count })
        labels.push(rawBuckets[firstDataIndex + 1].label)
      }

      if (firstDataIndex + 2 < rawBuckets.length) {
        buckets.push({ count: rawBuckets[firstDataIndex + 2].count })
        labels.push(rawBuckets[firstDataIndex + 2].label)
      }

      // Combine remaining buckets into 3 more buckets to make 6 total
      const remainingBuckets = rawBuckets.slice(firstDataIndex + 3)

      if (remainingBuckets.length > 0) {
        // Split remaining into 3 groups
        const groupSize = Math.ceil(remainingBuckets.length / 3)

        for (let i = 0; i < 3; i++) {
          const groupStart = i * groupSize
          const groupEnd = Math.min((i + 1) * groupSize, remainingBuckets.length)
          const group = remainingBuckets.slice(groupStart, groupEnd)

          if (group.length > 0) {
            const combinedCount = group.reduce((sum, b) => sum + b.count, 0)
            buckets.push({ count: combinedCount })

            // Generate label based on the group
            const firstBucket = group[0]
            const lastBucket = group[group.length - 1]

            if (i === 2 || groupEnd === remainingBuckets.length) {
              // Last group, use "X+" format
              // Make sure it's greater than the previous label's number
              let lastValue = firstBucket.lower
              if (labels.length > 0) {
                const prevLabel = labels[labels.length - 1]
                const match = prevLabel.match(/\d+/)
                if (match) {
                  const prevNumber = parseInt(match[0])
                  lastValue = Math.max(lastValue, prevNumber + 1)
                }
              }
              labels.push(`${lastValue}+`)
            } else {
              // Use "<X" format where X is the upper bound of the last bucket in this group + 1
              const upperBound = lastBucket.upper || lastBucket.lower
              labels.push(`<${upperBound + 1}`)
            }
          }
        }
      }
    }
  } else {
    // Use old buckets as-is
    buckets = rawBuckets.map(b => ({ count: b.count }))
    labels = rawBuckets.map(b => b.label)
  }

  const histogramBuckets = buckets.length
  const bucketW = 20
  const spacing = (histogramW - (histogramBuckets * bucketW)) / (histogramBuckets)

  const maxBucket = buckets.reduce((max, item) => Math.max(max, item.count), 0)
  return <svg style={containerStyle} viewBox={`0 0 300 115`}>
    {
      (scoreInfo.remoteScoreInfo && scoreInfo.remoteScoreInfo.buckets) && 
      <g>
        <text fill={"#314f4d"} x={20} y={30} fontSize={'25px'} fontFamily={'ProtoMono-Regular'} textAnchor='left' dominantBaseline={'middle'}>
          {scoreInfo.bestScore}
        </text>
        <text fill={"#314f4d"} x={20} y={50} fontSize={'10px'} fontFamily={'ProtoMono-Regular'} textAnchor='left' dominantBaseline={'middle'}>
          Your Score
        </text>
        <text fill={"#314f4d"} x={20} y={79} fontSize={'25px'} fontFamily={'ProtoMono-Regular'} textAnchor='left' dominantBaseline={'middle'}>
          {scoreInfo.remoteScoreInfo.highScore}
        </text>
        <text fill={"#314f4d"} x={20} y={100} fontSize={'10px'} fontFamily={'ProtoMono-Regular'} textAnchor='left' dominantBaseline={'bottom'}>
          Global Best
        </text>
        {
          buckets.map((bucket, i) => {
            const height = 90 * (bucket.count / maxBucket) 
            const adjHeight = height == 0 ? 2 : height
            return <g key={i}>
              <motion.rect x={histogramX + i * spacing + i * bucketW}
                y={90 - adjHeight} width={bucketW} height={adjHeight} fill={colors[i]}>
              </motion.rect>
            </g>
          })
        }
        {
          labels.map((label, i) => {
            const x = histogramX + i * spacing + i * bucketW + bucketW / 2
            return <text x={x} y={100}
              key={i}
              fontSize={'10px'} fontFamily={'ProtoMono-Regular'}
              textAnchor='middle' dominantBaseline={'bottom'}fill={"#314f4d"}>
            {label}
          </text>
          })
        }
      </g>
    }
  </svg>
}

export default RemoteScoreView;


